import { ReactComponent as VisibilityOffOutlined } from '../../../../assets/icons/visibility-off-outlined.svg';

export { VisibilityOffOutlined };
